import type { ReactNode } from 'react';
import { helper } from './Field.css';

export function HelperText({ children }: { children: ReactNode }) {
  return <p className={helper}>{children}</p>;
}
